// @flow
import React from 'react';
import { type FieldProps } from 'formik';

type Props = {
  ...FieldProps,
};

export const Hidden = ({ field }: Props) => {
  return (
    <input
      id={field.name}
      type="hidden"
      {...field}
      // to not trigger a React error when the field is initialize to undefined
      value={field.value || ''}
    />
  );
};
